/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/**
 * PointProps is identical to XAndY in @core/geometry, but
 * @internal
 */
export interface PointProps {
  readonly x: number;
  readonly y: number;
}
